<!--AFFICHAGE BLOC GOOGLE -->
<template>
  <v-container fluid >
    <v-row dense>
      <v-col cols="12">
    <v-card elevation="2"  v-if="this.condition()">
      <v-card-title> Equipement à la concurrence </v-card-title>

      <v-list two-line>
        <SimpleListItem
          v-bind:var="concurrence"
          data="assuranceTravaux"
          field="valeur"
          prefix="Assureur Travaux : "
        ></SimpleListItem>

        <SimpleListItem
          v-bind:var="concurrence"
          data="assuranceRC"
          field="valeur"
          prefix="Assureur RC : "
        ></SimpleListItem>
      </v-list>
    </v-card>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import SimpleListItem from "@/components/layout/SimpleListItem.vue";

export default {
  name: "Concurrence",
  props: ["etablissement"],
  components: {
    SimpleListItem,
  },
  computed: {
    concurrence: function () {
      return this.$store.getters.getbloc("concurrence", "donnees");
    },
  },
  methods: {
    condition() {
      return this.$store.getters.condition("concurrence", "donnees");
    },
  },
};
</script>
